/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowUpLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M197.65674,197.65723a8.00063,8.00063,0,0,1-11.31348,0L116,127.314,69.65723,173.65723A8.00066,8.00066,0,0,1,56,168V64a8.00039,8.00039,0,0,1,8-8H168a8.00038,8.00038,0,0,1,5.65723,13.65723L127.314,116l70.34278,70.34277A8.00034,8.00034,0,0,1,197.65674,197.65723Z" />
    </Svg>
  );
}

export default ArrowUpLeft;
